import { useState } from 'react';
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/outline';

// Define state groupings for US
const US_STATE_GROUPS = {
  east: [
    'CT', 'DE', 'FL', 'GA', 'MA', 'MD', 'ME', 'NC', 'NH', 
    'NJ', 'NY', 'PA', 'RI', 'SC', 'VA', 'VT', 'WV'
  ],
  central: [
    'AL', 'AR', 'IA', 'IL', 'IN', 'KS', 'KY', 'LA', 'MI', 
    'MN', 'MO', 'MS', 'ND', 'NE', 'OH', 'OK', 'SD', 'TN', 
    'TX', 'WI'
  ],
  west: [
    'AK', 'AZ', 'CA', 'CO', 'HI', 'ID', 'MT', 'NM', 'NV', 
    'OR', 'UT', 'WA', 'WY'
  ]
};

export default function StateFilter({ countryName, availableStates, selectedStates, onChange, events }) {
  const [expandedGroup, setExpandedGroup] = useState(null);

  /*
  if (countryName === 'Australia') {
    return (
      <div className="space-y-2">
        {AU_STATES.map(state => (
          <label key={state} className="flex items-center">
            <input
              type="checkbox"
              className="h-4 w-4 rounded border-gray-300 text-slate-600 focus:ring-slate-600"
              checked={selectedStates.includes(state)}
              onChange={() => {
                const newSelection = selectedStates.includes(state)
                  ? selectedStates.filter(s => s !== state)
                  : [...selectedStates, state];
                onChange(newSelection);
              }}
              disabled={!availableStates.includes(state)}
            />
            <span className={`ml-2 text-sm ${availableStates.includes(state) ? 'text-gray-600' : 'text-gray-400'}`}>
              {state}
            </span>
          </label>
        ))}
      </div>
    );
  }
  */
  if (countryName === 'United States') {
    return (
      <div className="space-y-4">
        {Object.entries(US_STATE_GROUPS).map(([region, states]) => {
          const availableRegionStates = states.filter(s => availableStates.includes(s));
          const selectedRegionStates = states.filter(s => selectedStates.includes(s));
          const isRegionPartiallySelected = selectedRegionStates.length > 0 && selectedRegionStates.length < availableRegionStates.length;
          const isRegionFullySelected = availableRegionStates.length > 0 && selectedRegionStates.length === availableRegionStates.length;
          
          return (
            <div key={region} className="border-b border-gray-200 pb-2">
              <button
                onClick={() => setExpandedGroup(expandedGroup === region ? null : region)}
                className="flex w-full items-center justify-between py-2 text-sm font-medium text-gray-900 group"
              >
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    className="h-5 w-5 rounded border-gray-300 text-slate-600 focus:ring-slate-600 mr-2"
                    checked={isRegionFullySelected}
                    ref={input => {
                      if (input) {
                        input.indeterminate = isRegionPartiallySelected;
                      }
                    }}
                    onChange={(e) => {
                      const newSelection = e.target.checked
                        ? [...selectedStates, ...availableRegionStates.filter(s => !selectedStates.includes(s))]
                        : selectedStates.filter(s => !states.includes(s));
                      onChange(newSelection);
                    }}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <span>{region.charAt(0).toUpperCase() + region.slice(1)}</span>
                  <span className="text-xs text-gray-500 ml-2">
                    ({availableRegionStates.length} states)
                  </span>
                </div>
                {expandedGroup === region ? (
                  <ChevronUpIcon className="h-4 w-4" />
                ) : (
                  <ChevronDownIcon className="h-4 w-4" />
                )}
              </button>
              
              {expandedGroup === region && (
                <div className="ml-4 mt-2 grid grid-cols-2 gap-3">
                  {states.map(state => {
                    const eventCount = events?.filter(event => 
                      event.StateNameShort === state
                    ).length || 0;
                    
                    return (
                      <label key={state} className="flex items-center justify-between">
                        <div className="flex items-center flex-1">
                          <input
                            type="checkbox"
                            className="h-5 w-5 rounded border-gray-300 text-slate-600 focus:ring-slate-600"
                            checked={selectedStates.includes(state)}
                            onChange={() => {
                              const newSelection = selectedStates.includes(state)
                                ? selectedStates.filter(s => s !== state)
                                : [...selectedStates, state];
                              onChange(newSelection);
                            }}
                            disabled={!availableStates.includes(state)}
                          />
                          <span className={`ml-2 text-sm ${availableStates.includes(state) ? 'text-gray-600' : 'text-gray-400'}`}>
                            <span className="text-base">{state}</span>
                          </span>
                        </div>
                        {availableStates.includes(state) && (
                          <span className="text-xs text-gray-500 ml-2">({eventCount})</span>
                        )}
                      </label>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  // Default to simple list for other countries
  return (
    <div className="space-y-2">
      {availableStates.map(state => {
        const eventCount = events?.filter(event => 
          event.StateNameShort === state
        ).length || 0;
        
        return (
          <label key={state} className="flex items-center justify-between">
            <div className="flex items-center flex-1">
              <input
                type="checkbox"
                className="h-4 w-4 rounded border-gray-300 text-slate-600 focus:ring-slate-600"
                checked={selectedStates.includes(state)}
                onChange={() => {
                  const newSelection = selectedStates.includes(state)
                    ? selectedStates.filter(s => s !== state)
                    : [...selectedStates, state];
                  onChange(newSelection);
                }}
              />
              <span className="ml-2 text-sm text-gray-600">{state}</span>
            </div>
            <span className="text-xs text-gray-500 ml-2">({eventCount})</span>
          </label>
        );
      })}
    </div>
  );
} 